export const categories = [
  {
    slug: 'chengrengaokao',
    name: '成人高考',
    description: '成人高等学校招生全国统一考试，国家承认学历，学信网可查，适合在职人员提升学历的首选途径。',
    icon: 'ri-book-read-line',
    articleCount: 48,
    studentCount: 125600,
    features: ['入学门槛适中', '学习形式灵活', '国家承认学历', '学费相对较低'],
  },
  {
    slug: 'zixuekaoshi',
    name: '自学考试',
    description: '高等教育自学考试，宽进严出，含金量高，适合自学能力强、时间自由的学员。',
    icon: 'ri-file-text-line',
    articleCount: 36,
    studentCount: 89200,
    features: ['无入学考试', '含金量最高', '学习时间自由', '费用最低'],
  },
  {
    slug: 'wangluojiaoyu',
    name: '网络教育',
    description: '现代远程教育，名校名师授课，随时随地在线学习，适合工作繁忙的在职人士。',
    icon: 'ri-computer-line',
    articleCount: 42,
    studentCount: 98300,
    features: ['名校资源', '在线灵活学习', '学习支持完善', '通过率较高'],
  },
  {
    slug: 'guojiakaifang',
    name: '国家开放大学',
    description: '教育部直属新型高等学校，免试入学，学习方式多样，毕业率高，是稳妥提升学历的选择。',
    icon: 'ri-building-line',
    articleCount: 30,
    studentCount: 156400,
    features: ['免试入学', '学习方式多样', '通过率高', '学费合理'],
  },
];

export const categoryFAQs = {
  chengrengaokao: [
    { q: '成人高考的报考条件是什么？', a: '报考高中起点升本科或高中起点升专科的考生应具有高中毕业文化程度。报考专科起点升本科的考生必须是已取得经教育部审定核准的国民教育系列高等学校、高等教育自学考试机构颁发的专科毕业证书、本科结业证书或以上证书的人员。' },
    { q: '成人高考一年有几次考试机会？', a: '成人高考每年只有一次全国统一考试，一般在10月份的最后一个周末举行。报名时间通常在8月中下旬至9月上旬，具体时间以各省教育考试院公布为准。' },
    { q: '成人高考的学历国家承认吗？', a: '成人高考属于国民教育系列，列入国家招生计划，国家承认学历，学信网终身可查。毕业后获得的学历证书可用于考研、考公务员、评职称、出国留学等。' },
  ],
  zixuekaoshi: [
    { q: '自学考试需要多长时间可以毕业？', a: '自学考试没有固定的学制要求，完全取决于个人的学习进度和考试通过情况。一般来说，如果每次考试都能顺利通过，专科最快1.5-2年，本科最快2-3年可以完成所有课程。' },
    { q: '自学考试的含金量如何？', a: '自学考试是我国高等教育的重要组成部分，其学历证书含金量在成人教育中是最高的，社会认可度也最高。自考学历不仅在国内受到认可，在国际上也有较高的认可度。' },
    { q: '自学考试可以免考部分课程吗？', a: '可以。凡取得大学英语四级（CET-4）及以上合格证书者可免考英语（一）、英语（二）；取得全国计算机等级考试（NCRE）一级及以上证书者可免考计算机应用基础等课程。' },
  ],
  wangluojiaoyu: [
    { q: '网络教育的学习方式是怎样的？', a: '网络教育采用"线上学习+线下考试"的混合模式。学员通过在线平台观看高清视频课程、完成在线作业、参与线上讨论，期末考试需到指定考点参加。学习时间和地点灵活自主，特别适合在职人士。' },
    { q: '网络教育的毕业证书和普通高校一样吗？', a: '网络教育毕业证书上会注明"网络教育"字样，但同样是国家承认的学历证书。证书由主办高校颁发，盖有学校公章，学信网可查。在考研、考公务员、职称评定等方面与普通高校学历具有同等效力。' },
  ],
  guojiakaifang: [
    { q: '国家开放大学和普通大学有什么区别？', a: '国家开放大学是教育部直属的、以现代信息技术为支撑的新型高等学校。它面向全体社会成员，强调优质教育资源的集聚、整合和共享。与普通大学相比，入学门槛更低、学习方式更灵活、学费更实惠。' },
    { q: '国家开放大学的学历可以考公务员吗？', a: '可以。国家开放大学的学历是国家承认的国民教育系列学历，在公务员考试中与普通高校学历具有同等报考资格。具体报考条件还需参考各招考岗位的要求。' },
  ],
};